module.exports = __webpack_public_path__ + "assets/img/s2_tab3.296e6bbb.png";